/* eslint-disable max-len */
export default {
  add: 'Agregar',
  aboutUs: 'Acerca de Nosotros',
  accessRequest: 'Solicitud de Acceso',
  accountInformation: 'Información de la Cuenta',
  activeDocuments: 'Pedidos Activos',
  addCard: 'Agregar una nueva tarjeta',
  address: 'Dirección',
  address2: 'Dirección:',
  addressToSend: 'Dirección de entrega',
  agreement: 'Acuerdo',
  approve: 'Aprobar',
  approveCart: 'Aprobar Carrito',
  approveCarts: 'Aprobar Carritos seleccionados',
  approveCartsInfo1: 'Para la aprobación masiva, se utilizará el método de pago "Facturación" para todos los carritos.',
  approveCartConfirm: '¿Realmente desea aprobar el carrito?',
  approveCartsConfirm: '¿Realmente desea aprobar los carritos seleccionados?',
  approved: 'Aprobado',
  available: 'Disponible',
  availability: 'Disponibilidad:',
  authorized: 'Autorizado',
  all: 'Todos',
  allCategories: 'Todas Categorías',
  bank: 'Banco',
  bankSlip: 'Boleto',
  bankSlipText1: 'Imprima el boleto y pague en el banco',
  bankSlipText2: 'o pague en intenet usando el código de barra',
  bankSlipText3: 'El período de validez del boleto es de 2 días hábiles',
  bankSlipText4: 'Para el pago mediante boleto hay una tarifa de $ 1,00 que se agregará al monto total de su compra',
  bankSlipVisualize: 'Clique para visualizar el boleto',
  beingPrepared: 'Pedido siendo preparado',
  before: 'Anterior',
  billing: 'Credito',
  billing2: 'Facturación',
  billed: 'Cantidad facturada:',
  birthday: 'Fecha de Cumpleaños:',
  brands: 'Marcas',
  buyDate: 'Fecha de compra',
  buyDate2: 'Fecha de compra:',
  buySolicitation: 'Solicitar Compra',
  cancel: 'Cancelar',
  canceled: 'Cancelado',
  categories: 'Categorías',
  cardInvalid: 'Tarjeta inválida, aceptamos sólo Visa, Mastercard y Elo.',
  cardName: 'Nombre que aparece en la tarjeta',
  cardNumber: 'Número de la tarjeta',
  cardNumberInvalid: 'Número de tarjeta inválido',
  cart: 'Carrito',
  cartEmpty: 'Carrito vacio',
  cartSolicitationText: 'Su carrito de compra fue enviado para un responsable',
  cartEstimateText: 'Su solicitud de presupuesto ha sido enviada.',
  cartChanged: 'Atención... Los ítems de su carrito fueron modificados,'
    + ' por favor revise los ítems antes de finalizar el pedido.',
  cartToApprove: 'Carritos para aprobar:',
  cartProducts: 'Productos en el carrito',
  cartOrderByDateAsc: 'Ordenar por fecha de inserción ascendente',
  cartOrderByDateDesc: 'Ordenar por fecha de inserción descendente',
  cartOrderByNameAsc: 'Ordenar por nombre ascendente',
  cartOrderByNameDesc: 'Ordenar por nombre descendente',
  captured: 'Realizado',
  currentCartWillChange: 'Su carrito actual será reemplazado, ¿le gustaría continuar?',
  city: 'Ciudad',
  change: 'Cambiar',
  changeAddress: 'Cambiar Dirección',
  changePayment: 'Cambiar Forma de Pago',
  changePasswordIsNotPossible: 'No es posible cambiar su contraseña,'
    + ' usted no ha solicitado una recuperación de contraseña.',
  company: 'Empresa',
  companyData: 'Datos de la Empresa',
  contact: 'Contáctenos',
  contactUs: 'Contáctenos',
  continueBuy: 'Continuar Comprando',
  confirm: 'Confirmar',
  confirmed: 'Confirmado',
  confirmPassword: 'Confirmar Contraseña',
  confirmNewPassword: 'Confirmar nueva contraseña',
  contract: 'Convenio',
  contractNotFound: 'Disculpe, no hay convenios encontrados.',
  contractProducts: 'Productos de Convenio',
  consultUs: 'Consúltenos',
  consultUsTime: 'Plazo: CONSÚLTENOS',
  copyOrder: 'Copiar Pedido',
  cancelOrder: 'Cancelar Pedido',
  cancellationOrder: 'Cancelación de orden',
  cancelOrderConfirm: 'De verdad quieres cancelar el pedido?',
  country: 'País',
  csv: 'CSV',
  checkoutContact: 'Nuestro equipo recibirá los productos solicitados y entrará en contacto con los precios.',
  credit: 'Tarjeta de Crédito',
  crossSelling: 'Cross Selling',
  crossSellingProduct: 'Productos Destacados',
  cleanCart: 'Limpiar Carrito',
  cleanFilters: 'Limpiar todos los filtros',
  clientCode: 'Código del Cliente:',
  clientCode2: 'Código Cliente:',
  clientDescription: 'Descripción del Cliente',
  code: 'Código: #',
  code2: 'Código:',
  codeSphere: 'Código de pedido interno:',
  codeSphere2: '| Código de pedido interno:',
  codeSolicitation: 'Código de la Solicitación:',
  cnpj: 'RUT',
  cpf: 'CPF',
  cep: 'Código Postal',
  currentPassword: 'Contraseña Actual',
  cvv: 'CVV',
  cvvInvalid: 'CVV inválido',
  days: 'Días',
  discount: 'Descuento',
  description: 'Descripción',
  debitOn: 'Débito en Línea',
  debit: 'Débito',
  decline: 'Rechazar',
  declineCart: 'Rechazar carrito',
  declineCarts: 'Rechazar carritos seleccionados',
  declineCartConfirm: '¿Realmente desea rechazar el carrito?',
  declineCartsConfirm: '¿Realmente desea desaprobar los carritos seleccionados?',
  deleteCard: 'Borrar Tarjeta',
  delivered: 'Pedido entregado',
  delivered2: 'Entregado',
  deliveryAllCountry: 'Entrega en todo Chile',
  deliveryAllCountryText: 'Tenemos la estructura necesaria para '
    + 'atenderlo de la mejor forma, donde quiera que usted esté.',
  deliveryType: 'TIPO DE ENTREGA',
  defaultAddress: 'Dirección predeterminada',
  details: 'Ver Detalles del Pedido',
  details2: 'Detalles',
  didYouMean: '¿Querías decir?',
  downloadApp: '¡Descargue nuestro App gratis!',
  downloadPdf: 'Ficha Técnica - PDF',
  documentList: 'Pedidos y presupuestos realizados:',
  documentList2: 'Pedidos y Presupuestos',
  documentStatus: 'Estado del Pedido',
  documentStatus2: '| Estado del Pedido:',
  emailCnpjMessage: 'E-mail ya registrado con ese RUT',
  emailCnpjMessage2: 'E-mail no relacionado con ese RUT',
  emailCnpjMessage3: 'Cliente no relacionado com ese RUT',
  entry: 'Entrar',
  error: '¡ERROR!',
  errorOcurred: 'Disculpe ocurrio un error',
  errorOcurred2: 'Disculpe ocurrio un error.',
  errorTryLater: 'Ocurrio un error, intente más tarde.',
  emailCnpj: 'E-mail/RUT',
  emailCnpjCpf: 'E-mail/RUT',
  emailPlaceholder: 'Ingrese su e-mail',
  estimate: 'Cotización',
  estimateSolicitation: 'Pedir una Cotización',
  estimateTime: 'Plazo de Entrega',
  especification: 'Especificaciones:',
  expirationDateInvalid: 'Fecha de expiración inválida',
  expirationMonthInvalid: 'Mes de expiración inválido, debe ser entre 01 y 12',
  expirationYearInvalid: 'Año de expiración inválido',
  expirationPlaceholder: 'MM/AA',
  exit: 'Salir',
  features: 'Características',
  finalize: 'Finalizar',
  finalize2: 'Finaliza',
  finalizeIn: 'Finaliza en',
  finalized: 'Finalizado',
  finalizeBuy: 'Finalizar Compra',
  finalizeOrder: 'Finalizar Pedido',
  firstName: 'Primer Nombre',
  fileGenerate: 'Generar Archivo',
  flagInvalid: 'No aceptamos esta bandera de tarjeta',
  forgotPassword: '¿Olvidó su contraseña? Ingrese su e-mail.',
  forgotPassword2: 'Olvidó la contraseña',
  generateSummary: 'Generar informe de pedidos',
  general: 'General',
  home: 'Inicio',
  howWorks: 'Como Funciona',
  immediateTime: 'Plazo Máximo: INMEDIATO',
  insertNewPassword: 'Ingrese su nueva contraseña.',
  inTransport: 'En transporte',
  insertEmail: 'Ingrese su e-mail',
  insertCnpj: 'Ingrese su RUT',
  invalidEmail: 'E-mail inválido',
  invalidCNPJ: '¡RUT inválido!',
  invalidAmount: 'CANTIDAD AÑADIDA NO EN STOCK',
  invalidAmount2: 'La cantidad agregada no está disponible en stock, el artículo tiene ',
  invalidAmount3: 'en stock Si desea una mayor cantidad, consulte disponibilidad con nuestras televentas: ',
  invalidCep: '¡Código Postal inválido!',
  invoiceIssued: 'Faturado',
  installmentsNumber: 'Número de cuotas:',
  invoiceIssuedPartially: 'Parcialmente Faturado',
  items: 'Ítems',
  json: 'JSON',
  job: 'Cargo',
  lastName: 'Apellido',
  birthDate: 'Fecha de nacimiento (Opcional)',
  birthDate2: 'Fecha de nacimiento',
  punchOut: 'Punch Out',
  punchOutTitle: 'ENTER a través de Punch Out',
  punchOutText: 'iniciar sesión a través de punch out',
  buyPunchOut: 'finalizá lo punch out',
  limitCartWarning: 'Usuario sin permiso para ver este carrito',
  loading: 'Cargando...',
  login: 'Iniciar sesión',
  loginForgotPassword: '¿Olvido su contraseña?',
  loginButton: 'ENTRAR',
  loginText: 'Si usted ya tiene una cuenta con nosotros, inicie sesión.',
  loginTitle: 'ENTRAR',
  loginRegisterSolicitation: 'Registrarse',
  loginError: '¡ERROR!',
  maxTime: 'Plazo Máximo:',
  mySolicitations: 'Mis solicitaciones:',
  minimumOf: 'Mínimo de',
  minimumPayment: 'Mínimo de $',
  minimumPayment2: 'para finalizar la compra',
  myInformations: 'Mis Informaciones',
  needHelp: '¿Necesita ayuda?',
  needHelpText: 'Nuestra postventa está siempre disponible para aclarar las dudas de su pedido.',
  navigation: 'Navegación',
  newPassword: 'Nueva contraseña',
  next: 'Próximo',
  newApp: 'Nuevo App para una experiencia única.',
  notAuthorized: 'No autorizado',
  noneDocument: 'Ningún pedido/presupuesto realizado.',
  normalDelivery: 'Entrega normal',
  noLimit: 'No se puede finalizar la compra. Por favor, póngase en contacto con el administrador de'
    + ' su contrato / cuenta para ver el saldo disponible.',
  observationText: 'Agregar comentarios',
  observationTextNortel: 'Agregar notas a lo credito (límite de 75 caracteres)',
  pageNotFound: '¡Página no encontrada!',
  panel: 'Panel',
  password: 'Contraseña',
  passwordDifferents: 'Las contraseñas son diferentes.',
  passwordPlaceholder: 'Ingrese su contraseña',
  passwordPlaceholder2: 'Confirme su contraseña',
  passwordErrorMessage: 'La contraseña actual debe ser mayor o igual a 6 caracteres y menor que 50.',
  passwordErrorMessage2: 'La contraseña debe ser mayor o igual a ',
  passwordErrorMessage3: ' caracteres y menor que ',
  passwordSuccessChanged: 'Contraseña cambiada con éxito.',
  passwordInvalid: 'La contraseña actual es inválida.',
  passwordChange: 'Cambiar Contraseña',
  passwordInsert: 'Ingrese su nueva contraseña.',
  payWithBankSlip: 'Pagar con Boleto',
  paid: 'Pagado',
  payment: 'Pago',
  paymentTerm: 'Pago',
  paymentType: 'Forma de Pago',
  paymentType2: 'Forma de Pago:',
  paymentMade: 'Pago Confirmado',
  personalData: 'Datos Personales',
  phone: 'Teléfono:',
  pdf: 'PDF',
  product: 'Producto',
  products: 'Productos',
  productType: 'Tipo de producto',
  productBought: 'producto(s) comprado(s)',
  productInformation: 'Información del Producto',
  productsPromotion: 'Productos en Promoción',
  productsSimilar: 'Productos Alternativos',
  markAll: 'Marcar Todos',
  master: 'Principal',
  zeroedStockMain: 'Si el artículo está en stock diferente al principal, comuníquese con el vendedor responsable de su cuenta.',
  province: 'Comuna',
  price: 'Precio',
  price2: 'Precio:',
  privacyPolicy: 'Política de privacidad',
  quantity: 'Cant.',
  quantity2: 'Cantidad:',
  quality: 'Garantia de Calidad',
  qualityText: 'Trabajamos solamente con productos de las mejores marcas del mercado.',
  readToSend: 'Pedido listo para enviar',
  recoverPassword: 'Recuperar Contraseña',
  registerSolicitation: 'Solicitación de Registro',
  remove: 'Remover',
  return: 'Volver',
  returnHome: 'Volver para Inicio',
  results: 'Resultados',
  requestAccess: 'Solicitar Acceso',
  requestAccessText: '¿Su empresa ya tiene un registro? Solicitar la liberación de su acceso',
  saveCardText: 'Guardar datos de la tarjeta para futuras compras',
  search: 'Buscar',
  searchProduct: 'Buscar por producto...',
  searchTerm: 'Buscar por palabra...',
  sector: 'Sector',
  selected: 'Seleccionado',
  selectAddressToTake: 'Seleccione la dirección de retiro:',
  selectAddressToSend: 'Seleccione la dirección de entrega:',
  selectDeliveryType: 'Seleccione el tipo de entrega:',
  selectPaymentMethod: 'Seleccione la forma de pago:',
  sellMultiple: 'Múltiplo de Venta:',
  sellMultipleNeeds: 'La cantidad debe ser múltiplo de',
  showing: 'Mostrando',
  soneparCode: 'Código Sonepar:',
  securityCode: 'Código de seguridad:',
  st: 'IVA',
  state: 'Ciudad',
  spot: 'Spot',
  spotlight: 'Destacados',
  spotlightProducts: 'Productos Destacados',
  subTotal: 'Subtotal',
  subCategories: 'Subcategorías',
  summary: 'Resumen',
  successBuy: 'Su compra fue realizada con éxito',
  successRegister: 'Acceso solicitado con éxito',
  successRegisterText: 'Le enviaremos un e-mail una vez que su acceso esté habilitado..',
  successSolicitation: 'Solicitación enviada con éxito',
  successSolicitationText: 'Le enviaremos un email cuando su solicitación sea aprobada.',
  storeTake: 'Retirar en la tienda',
  spotItemsError: '"No se pueden comprar más artículos que la cantidad disponible"',
  orderMade: 'Pedido realizado',
  orderDetail: 'Detalles del pedido',
  orderCodeOptional: 'Orden de Compra (Opcional)',
  orderMadeBy: 'Pedido realizado por: ',
  orderSolicitedBy: 'Pedido solicitado por: ',
  of: 'de',
  take: 'Retirar:',
  thanks: 'Gracias',
  toBuy: 'para finalizar la compra',
  total: 'Total',
  total2: 'Total:',
  totalCartDetails: '(Valor + %{tax})',
  timeDelivered: 'Tiempo de entrega',
  transportCompany: 'transportista',
  transportDocument: 'transportista RUT',
  unmarkAll: 'Desmarca todo',
  undefined: 'Indefinido',
  userBlocked: 'Usuario está bloqueado.',
  userHasNoActiveContract: 'Usuario inactivo',
  userNotFound: 'Usuario no encontrado.',
  userInvalidPassword: 'Contraseña invalida.',
  userInvalid: 'Usuario o contraseña inválida.',
  userTerms: 'Términos de uso',
  unavailable: 'NO DISPONIBLE',
  unityPrefix: 'Un:',
  visualizeCart: 'Ir al Carrito',
  visualizeDetail: 'Ver detalles',
  xml: 'XLM',
  welcome: 'Bienvenido',
  withOutContract: 'Sin Convenio',
  withoutStock: 'A consultar',
  wishToCopyOrder: '¿Desea realmente copiar el pedido?',
  wishToApproveCart: '¿Desea realmente ver el carrito?',
  wishToDeleteCard: '¿Realmente quieres eliminar la tarjeta de',
  workingDays: 'días hábiles',
  xpedTooltipText: 'Ingrese su número de orden de compra. Estos datos se mostrarán en la factura xPed.'
    + ' El campo está limitado a 10 caracteres y solo se permiten letras, números,'
    + ' guiones (-), subrayado (_), coma (,) y barra diagonal (/ \\) ',
  awaitingApproval: 'En espera de aprobación',
  disapproved: 'Desaprobado',
  awaitingNf: 'En espera de NF',
  totalBilled: 'Total facturado',
  parcialBilled: 'Partially Billed',
  filterBy: 'Filtrar por:',
  filterByContract: 'Filtrar por Contrato:',
  filterByStatus: 'Filtrar por Status:',
  attention: 'Atencion',
  selectDefaultAddress: '¿Desea establecer la dirección elegida por defecto?',
  yes: 'Si',
  no: 'No',
  invalidItemsCart: 'No se puede realizar el pago ya que hay artículos en el carrito que están agotados',
  cantAddToCart: 'No se puede agregar este artículo al carrito porque no hay stock',
  picking: 'Separando',
  deliveredToCarrier: 'Entregar el transportista',
  outForDelivery: '  Fuera para entrega',
  outForDeliveryPrev: 'Prev:',
  availableCustumer: 'Retiro disponible',
  done: 'Efectuado',
  errorPurchaseContact: 'Error de pago, contacte con la administración de la tienda.',
  errorInvalidDoc: 'Documento inválido, validar RUT informado.',
  errorMinimumPrice: 'El carrito no puede ser inferior a {?}',
  errorInvalidCard: 'Datos de la tarjeta no válidos, valide nuevamente.',
  errorLocation: 'Dirección no encontrada.',
  errorLocationOrClient: 'Dirección o cliente no encontrado.',
  errorForbidden: 'No se puede finalizar la compra. Póngase en contacto con su administrador de cuenta/contrato.',
  errorMaxObservation: 'El campo de observación no puede superar los caracteres {?}.',
  errorGkoClientNotFound: 'Dirección no encontrada, comuníquese con la administración de la tienda.',
  errorPurchaseNotFinished: 'Error de pago, contacte con la administración de la tienda.',
  errorNotFoundDoc: 'CNPJ/CPF del cliente no encontrado, por favor contacte a la administración de la tienda.',
  productStock: 'Estoque',
  productTotalStock: 'Total',
  productToFavorite: 'Favorito',
  productFavorite: 'Productos Favoritos',
  cartStatus: 'Estado del carrito : #',
  pendingApproval: 'Aprobación pendiente',
  dates: 'Datas',
  responsibles: 'Responsable',
  status: 'Status',
  approver: 'Aprobador',
  request: 'Petición',
  requester: 'Solicitante',
  open: 'Abierto ',
  billetWarningMessage: 'Su pedido se facturará dentro de las 48 horas posteriores a la confirmación del pago del boleto.',
  successBuyBillet: 'Su pedido se ha realizado correctamente. Para finalizar la compra, realice el pago del boleto hasta la fecha de vencimiento.',
  checkoutGenerateTicket: 'Finalizar pedido y generar ticket',
  stateRegistrationNotice: 'En caso de IE y condición de contribuyente no ICMS, póngase en contacto después de completar el registro.',
  noticeResaleOption: 'El propósito de reventa es obligatorio para completar el registro estatal',
  errorDateReported: 'La fecha ingresada no puede ser mayor que la fecha actual',
  incompletePhoneError: 'Número de teléfono incompleto proporcionado',
  birthError: 'Ingrese una fecha de nacimiento válida',
  phoneError: 'Ingrese un número de teléfono válido',
  birthError2: 'No se encuentra la fecha de nacimiento del cliente, comuníquese con la administración de la tienda.',
  phoneError2: 'No se encontró el teléfono del cliente, comuníquese con la administración de la tienda.',
  noticeMaximumContractValue1: 'El contrato',
  noticeMaximumContractValue2: 'superó el valor máximo',
  noticeMaximumContractValue3: 'revise los elementos de este contrato para que se ajusten al monto máximo.',
  noticeMaximumValueContracts1: 'Contratos',
  noticeMaximumValueContracts2: 'exceder los valores máximos',
  noticeMaximumValueContracts3: 'por favor revise los ítems de estos contratos para determinar si los valores máximos son adecuados.',
  erroMaximumContractValue: 'Valor del contrato no informado, comuníquese con la administración de la tienda.',
  cartHistory: 'Historial del carrito',
  approvalDate: 'Fecha de aprobación',
  requestDate: 'Fecha de solicitud',
  instructionsImportingProductList: 'Instrucciones para importar la lista de productos',
  selectFile: 'Seleccionar un archivo',
  importListInstruction1: 'Descargar la plantilla de importación.',
  importListInstruction2: 'Descargar plantilla de hoja de cálculo',
  importListInstruction3: 'Cargar los productos y sus cantidades al documento a importar.',
  importListInstruction4: 'Después de cargar todos los productos deseados, importe la hoja de cálculo (formato XLS) en el área de abajo.',
  importListInstruction5: 'Subir archivo',
  cartImportUploadWaitMessage: 'Por favor, espere unos segundos mientras se realiza la carga',
  importList: 'Importar lista',
  line: 'línea',
  dragAndDropCartErrorTitle: 'Los siguientes productos no han sido encontrados',
  noAggregatedProductsToCart: 'Contiene %{0} productos en el carrito',
  goToCartNow: 'Ir al carrito ahora',
  UploadedEmpty: 'El archivo subido está vacío',
  LGPDCookiesMessage: 'Este sitio web utiliza cookies y datos personales de acuerdo con nuestros Términos de uso y Política de privacidad, al continuar navegando en este sitio web, declara conocer estas condiciones.',
  Proceed: 'Continuar',
  empty: 'Vazio',
  imageIllustrative: 'Imagenes solo para fines ilustrativos',
  pickUpAtLockerStore: 'Recogida en tienda | OPCIÓN DE TAQUILLA',
  minimumBillingDate: 'Programe su Compra',
  billingDateTooltip: 'Programe su compra. Cuando coloque una fecha futura, la factura de su pedido se emitirá solo a partir de esa fecha. Es válido para entregas totales o parciales.',
  billingDateInformation: 'La fecha anterior solo se valida para la condición de pago de FACTURACIÓN',
  invalidMinimumBillingDate: 'No es posible finalizar la compra porque la fecha mínima de facturación no es válida.',
  errorMinimumBillingDate: 'No puede pagar la compra porque ha informado una fecha de facturación mínima para el método de pago que no sea FACTURACIÓN',
  errorMinorMinimumBillingDate: 'La fecha seleccionada es menor que la fecha actual',
  bidSizeInformative: 'Ejemplo: está comprando 1000 metros, pero le gustaría recibirlos en dos ofertas de 500 m, así que complete 500 m en el campo de tamaño de la oferta.',
  bidSize: 'Tamaño de la oferta',
  bidSize2: 'Tamaño de la oferta:',
  BidAvailable: 'Oferta disponible',
  reportProblem: 'Reportar un Problema',
  websiteReview: '¿Qué opinas de nuestro sitio?',
  reasonForFeedback: 'Tengo un comentario sobre',
  feedback: '¿Qué quieres compartir con nosotros?',
  submit: 'Enviar',
  productFeedbackNotice: 'Para enviarlo, rellene todos los campos de arriba',
  selectAnOption: 'Seleccione una opción',
  freightDays1: 'Recibir dentro de los',
  freightDays2: 'día(s) hábil(es) posteriores a la confirmación del pago o la confirmación de su pedido de compra.',
  purchaseFeedbackRating: '¿ Cómo calificas tu experiencia de compra ?',
  cancelFeedBackButton: 'Ahora no...',
  purchaseFeedbackRatingWarning: 'Para enviar tu comentario sobre la compra es necesario dar una nota',
  purchaseFeedbackOpinionTextWarning: 'Para enviar tu comentario sobre la compra es necesario rellenar el texto anterior',
  unit: 'Unidad',
  requiredEmail: 'Es obligatorio informar el correo electrónico',
  requiredName: 'Es obligatorio informar el nombre',
  requiredPhone: 'Es obligatorio indicar el número de teléfono',
  requiredUnit: 'Es obligatorio informar a la unidad',
  requiredField: 'Campo obligatorio',
  managerEmail: 'Correo electrónico del gestor',
  invalidManagerEmail: 'Correo electrónico del gestor no válido',
  ProductsInCartWithInvalidMultipleQuantities: 'Productos en la cesta con múltiples cantidades no válidas',
  requiredDeliveryAddress: 'Debe seleccionar una opción de entrega',
  invoiceDevolutions: 'Devoluciones',
  pending: 'Pendientes',
  accepted: 'Aceptadas',
  recused: 'Rechazadas',
  finished: 'Realizadas',
  cancelled: 'Canceladas',
  devolutionSolicitation: 'Solicitud de devolución',
  newDevolutionSolicitation: 'Nueva solicitud de devolución',
  salesInvoice: 'Factura de venta',
  productCode: 'Código',
  salesInvoiceProducts: 'Productos de la Factura de Venta',
  qtyToReturn: 'Cantidad a devolver',
  quantityReturned: 'Cantidad devuelta',
  totalQuantity: 'Cantidad total',
  returnInformation: 'Información sobre la Devolución',
  openRequest: 'Abrir solicitud',
  reason: 'Razón',
  detailedDescription: 'Descripción detallada',
  freight: 'Flete',
  returnType: 'Tipo de devolución',
  hasReturnLetter: 'Tiene una carta de devolución',
  contactEmail: 'Correo electrónico de contacto',
  attachment: 'Anexo',
  uploadFile: 'Cargar archivo',
  salesInvoiceNotFound: 'Factura de venta no encontrada',
  unknownErrorTryingToFindInvoice: 'Error desconocido al intentar localizar esta factura.',
  noFileSelectedForSubmission: 'No se ha seleccionado ningún archivo para cargar',
  unknownErrorWhenSavingFile: 'Error desconocido al guardar el archivo',
  mandatoryFillSalesInvoiceNumber: 'Obligatorio para rellenar el número de la factura de venta',
  productNeedToOpenReturnRequest: 'Es necesario devolver al menos 1 producto para abrir la solicitud de devolución',
  mandatoryToFillReasonToOpenReturnRequest: 'Obligatorio rellenar el motivo de la apertura de la solicitud de devolución',
  mandatoryDescriptionToOpenReturnRequest: 'Es obligatorio introducir una descripción para abrir la solicitud de devolución',
  mandatoryFreightTypeToOpenReturnRequest: 'Tipo de carga requerido para abrir la solicitud de devolución',
  mandatoryReturnTypeToOpenReturnRequest: 'Es obligatorio informar del tipo de devolución para abrir la solicitud de devolución',
  mandatoryReturnLetterToOpenReturnRequest: 'Obligación de informar si hay una carta de devolución para abrir la solicitud de devolución',
  requiredSelectContactEmailsToOpenReturnRequest: 'Obligatorio para seleccionar los correos electrónicos de contacto para abrir la solicitud de devolución',
  unknownErrorWhenOpeningReturnRequest: 'Error desconocido al abrir la solicitud de devolución',
  returnRequestOpenSuccessfully: 'La solicitud de devolución se ha abierto con éxito',
  noReturnDevolutionSolicitationMade: 'No se ha encontrado ninguna solicitud de devolución',
  requestInvoiceDevolution: 'Solicite un devolución',
  invoiceDevolutionValue: 'Valor del comprobante de devolución: ',
  invoiceDevolutionNumber: 'Número del comprobante de devolución: ',
  nciCode: 'Código NCI: ',
  dateOfDevolution: 'Fecha de devolución: ',
  requestingUser: 'Usuario solicitante: ',
  invoiceDevolutionPending: 'Pendiente',
  invoiceDevolutionAccepted: 'Aceptado',
  invoiceDevolutionRecused: 'Recusado',
  invoiceDevolutionFinished: 'Finalizado',
  invoiceDevolutionCancelled: 'Cancelado',
  NCIDetails: 'Detalles de la solicitud de devolución',
  invoiceDevolutionReasonForOpening: 'Motivo de la apertura: ',
  invoiceDevolutionProductCode: 'Código del producto: ',
  invoiceDevolutionQuantity: 'Cantidad: ',
  invoiceDevolutionPrice: 'Precio: ',
  cancelInvoiceDevolution: 'Cancelar la Devolución',
  cancelInvoiceDevolutionWarning: 'La solicitud de devolución %{0} se cancelará...',
  cancelInvoiceDevolutionWarning2: 'No será posible revertir esta acción, ¿realmente quieres hacerlo?',
  invoiceDevolutionCancelledSuccessfully: 'Solicitud de devolución cancelada con éxito',
  notShowNCIDetails: 'No fue posible mostrar los detalles de esta solicitud de devolución',
  openSolicitation: 'Solicitud abierta',
  pendingSolicitation: 'Solicitud pendiente',
  approvedSolicitation: 'Solicitud aprobada',
  finalizedSolicitation: 'Solicitud finalizada',
  rejectSolicitation: 'Solicitud denegada',
  cancelledSolicitation: 'Solicitud anulada',
  cifSolicitation: 'A cargo del cliente',
  fobSolicitation: 'A cargo del Nortel',
  sphereRejectSolicitation: 'Sphere se negó a abrir esta solicitud de devolución...',
  invoiceNotRelatedToCustomer: 'Esta factura de venta no está relacionada con este cliente.',
  salesInvoiceOnlyAcceptsNumbers: 'La factura de venta sólo acepta números.',
  salesInvoiceNumberNotFound: 'No se ha encontrado el número de la factura de venta.',
  clientCodeNotFound: 'Código de cliente no encontrado.',
  notPossibleToCancelThisSolicitation: 'It was not possible to cancel this return request...',
  selectClientContacts: 'Seleccionar contacto(s)',
  NCINumberNotFound: 'Código NCI no informado.',
  responsibleForReceiving: 'Responsable de recibir',
  deliverySector: 'Sector de la entrega',
  invalidResponsibleReceiving: 'Es obligatorio informar al responsable de la recepción',
  invalidDeliverySector: 'Es obligatorio informar al sector de la entrega',
  quantityDoesNotSuitMe: 'Esta cantidad no me convienee',
  quantityWishBuy: 'Digite a quantidade que deseja comprar:',
  okButton: 'OK',
  leadTimeNotFound: 'No se pudo encontrar el LeadTime para este producto, por favor inténtelo más tarde...',
  sampleNumber: 'Ej: 50.73',
  requiredQuantity: 'Es obligatorio informar de la cantidad',
  reportedQuantityGreaterTotalStock: 'La cantidad declarada debe ser superior a las existencias totales disponibles',
  displayProducts: 'Ver',
  quantityAvailable: 'Cantidad disponible en:',
  requestUserName: 'Nombre del solicitante',
  requestUserEmail: 'Correo electrónico del solicitante',
  requestUserInformation: 'Información del solicitante',
  invalidPunchoutUserAccess1: 'El usuario "%{0}" no pertenece a una cuenta Punchout para realizar compras, sólo para consultar el catálogo.',
  invalidPunchoutUserAccess2: 'Como el usuario "%{0}" pertenece a una cuenta de Punchout, es necesario iniciar sesión en una sección de Punchout para realizar una compra.',
  invalidPunchoutUserAccess3: 'Póngase en contacto con el administrador EDI de Time Digital-Nortel.',
  userHasNoPriceContract: 'El aprobador no tiene acceso al acuerdo de precio del carrito seleccionado',
  userHasNoPriceSpotPermission: 'El aprobador no tiene acceso al precio spot del carrito seleccionado',
  productsWithProblem: 'Los productos con problemas, por favor póngase en contacto con el administrador.',
};
